import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20studio%20scene%20with%20multiple%20glowing%20screens%20displaying%20social%20media%20feeds%20and%20video%20thumbnails%2C%20warm%20amber%20and%20crimson%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20background%20with%20golden%20highlights%2C%20editorial%20photography%20style%2C%20dramatic%20depth%20of%20field%2C%20modern%20media%20control%20room%20vibe%2C%20intense%20contrast&width=1920&height=1080&seq=chigua-hero-main&orientation=landscape"
        alt="吃瓜视频首页背景 - 网红黑料实时追踪与明星八卦每日更新"
        title="吃瓜视频 - 网红黑料实时追踪"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <div className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30">
          <i className="ri-fire-line text-primary-400 text-sm"></i>
          <span className="text-primary-300 text-xs font-medium whitespace-nowrap">每日更新 · 实时追踪</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          吃瓜视频
        </h1>
        <p className="text-base md:text-lg text-white/70 mb-8 max-w-xl leading-relaxed">
          网红黑料实时追踪 · 明星八卦每日更新
          <br />
          全网最全吃瓜视频在线观看平台
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/remen"
            className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始吃瓜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/wanghong"
            className="px-8 py-3 rounded-full bg-white/10 hover:bg-white/20 text-white font-medium text-sm border border-white/30 transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            网红黑料
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-8 md:gap-12">
          {[
            { num: '580万+', label: '日访问量' },
            { num: '1.2万+', label: '视频总量' },
            { num: '230万+', label: '活跃用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.num}</div>
              <div className="text-xs text-white/50 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}